import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, Event, RouterOutlet } from '@angular/router';
import { Subscription, Observable } from 'rxjs';          // 👈 agrega Observable
import { filter } from 'rxjs/operators';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { AsyncPipe } from '@angular/common';
import { PageTitleService } from '../../services/page-title/page-title.service';
import { environment } from '../../../environments/environment';

/** Modos de ancho del contenido; la propiedad es opcional en los environments. */
type FullWidthLayoutMode = 'off' | 'scorecards' | 'all';

@Component({
  selector: 'app-layout',
  standalone: true,
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, AsyncPipe],
})
export class LayoutComponent implements OnInit, OnDestroy {
  /** Pantallas con ancho completo cuando environment.fullWidthLayout = 'scorecards'. */
  private static readonly FULL_WIDTH_ROUTES = ['/quality_scorecard', '/risk_adjustment_scorecard'];

  sidebarOpen = false;
  showWelcome = true;
  isFullWidth = false;
  title$!: Observable<string>;

  private routerSubscription = new Subscription();

  constructor(
    private router: Router,
    private pageTitle: PageTitleService
  ) {}

  ngOnInit() {
    this.title$ = this.pageTitle.title$;
    this.updateFullWidth(this.router.url);

    this.routerSubscription.add(
      this.router.events
        .pipe(filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe((e: NavigationEnd) => {
          this.sidebarOpen = false;
          this.updateFullWidth(e.urlAfterRedirects || e.url);
        })
    );
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  /**
   * Decide si el contenido va a 100% de ancho segun environment.fullWidthLayout:
   * 'all' (todo el site), 'scorecards' (solo esas pantallas) u 'off'.
   * Por defecto (sin la propiedad en el environment) va a 100% en todo el site.
   */
  private updateFullWidth(url: string): void {
    // La propiedad es opcional en los environments: si no esta, se asume 'all'.
    const mode = (environment as { fullWidthLayout?: FullWidthLayoutMode }).fullWidthLayout ?? 'all';

    if (mode === 'all') {
      this.isFullWidth = true;
      return;
    }

    if (mode === 'scorecards') {
      const path = (url || '').split('?')[0];
      this.isFullWidth = LayoutComponent.FULL_WIDTH_ROUTES.some(r => path.startsWith(r));
      return;
    }

    this.isFullWidth = false;
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }
}
